export default "/images/vendor/flag-icon-css/flags/4x3/so.svg?1392d24855dd708a0ee908bd27c2e25e";